'use client';
import { useRef, useState } from 'react';
import { useMagneticButton } from '@/app/utils/useMagneticButton';
import styles from './ContactForm.module.css';
import gsap from 'gsap';

export default function ContactForm() {
  const audioRef = useRef(null);

  const magneticProps = useMagneticButton(0.15, 1.03);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    audioRef.current.currentTime = 0;
    audioRef.current.play().catch(e => console.log('Audio play failed:', e));
    gsap.timeline().to("#ticketnavbar", { transform: "translateY(50%)", duration: 1 }).to("#ticketnavbar", { transform: "translateY(0%)", duration: 2 })
  };

 

  return (
    <div className={styles.formCard}>
      <audio ref={audioRef} src="/print.mp3" preload="auto" />

      <div className={styles.agent}>
        <div className={styles.agentAvatar}>
          <img src="/avatar-placeholder.png" alt="Support" />
        </div>
        <div className={styles.agentInfo}>
          <h3>Customer Support</h3>
          <p>+216 98 648 548 90 050 106</p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className={styles.form}>


        <button type="submit" className={styles.submitBtn} {...magneticProps}>
          Add to Cart
        </button>
      </form>
    </div>
  );
}
